export default __webpack_public_path__ + "static/media/Church Ceremony-0137_tn.f0bc83ae.jpg";